import { ProductsOrder } from "../common/order/ProductsOrder";
import { ProductsRepair } from "common/order/ProductsRepair";
import sendRequest2 from "hooks/useAxios2";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Helmet from "react-helmet";
import colors from "react-multi-date-picker/plugins/colors";

export function FactorList({ logo }) {
  const [listFactor, setListFactor] = useState([]);
  const [updater, setUpdater] = useState(true);
  const product_id = useParams();
  // console.log("product_id.userType", product_id.userType);
  const change = (data) => {
    return data.map((value) => {
      return { ...value };
      //       mtm:value.url,
    });
    //  return  {
    //       ...data2,
    //       mtm: data2.url,
    //       complate_pay_tm: data2.cover_file_id,
    //       sendtm: data2.title,
    //       order_code: data2.address,
    //       order_type: data2.tell,
    //       main_status: data2.mobile,
    //       total_amount: data2.whatsapp,
    //       total_discount: data2.description,
    //     }
  };

  useEffect(() => {
    sendRequest2("get_product_orders", {
      product_id: product_id.product_id,
      business_id: product_id.business_id,
      mtm: product_id.mtm,
    }).then(({ data }) => {
      // setListFactor(change(data.data));
      setListFactor(data.data);
    });
  }, [updater]);
  console.log("h factor", listFactor);
  return (
    <>
      <Helmet>
        <title> (سفارشات)لیست خرید گروهی </title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>
      {listFactor.length > 0 ? (
        <>
          {listFactor?.map((value, index) => {
            return (
              <div className="order-container">
                {/* <ProductsOrder
                  pageType="groupList"
                  data={value}
                  index={index}
                ></ProductsOrder> */}
                <ProductsRepair
                  pageType="groupList"
                  data2={value}
                  index={index}
                  updater={updater}
                  setUpdater={setUpdater}
                  userType={product_id.userType}
                ></ProductsRepair>
              </div>
            );
          })}
        </>
      ) : (
        <p style={{ marginRight: "10px" }}>سفارشی وجود ندارد</p>
      )}
    </>
  );
}
